/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$multi-content-stage-teaser-top-left-radius: 0 !default;
$multi-content-stage-teaser-top-right-radius: 0 !default;
$multi-content-stage-teaser-bottom-left-radius: 0 !default;
$multi-content-stage-teaser-bottom-right-radius: 0 !default;
$multi-content-stage-teaser-shadow: none !default;
$multi-content-stage-teaser-active-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2) !default;
$multi-content-stage-headline-declaration: abstract !default;
$multi-content-stage-text-declaration: copy !default;
$multi-content-stage-icon-headline-margin-right: 8px !default;
$multi-content-stage-icon-headline-margin-top: 0 !default;
// $multi-content-stage-override-headline-font-size: inherit !default; // only used to overwrite default font settings
// $multi-content-stage-override-headline-line-height: inherit !default; // only used to overwrite default font settings
// $multi-content-stage-override-text-font-size: !default; // only used to overwrite default font settings
// $multi-content-stage-override-text-line-height: !default; // only used to overwrite default font settings
$multi-content-stage-content-box-radius: 0 !default;
$multi-content-stage-content-box-shadow: none !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  color: v(color);
}

.#{$prefix}mcs {
  position: relative;
  width: 100%;
  height: auto;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
}

.#{$prefix}mcs-content-group {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.#{$prefix}mcs-background {
  position: absolute;
  margin: 0 auto;
  width: 100vw;
  height: 100%;
  top: 0;
  left: 50%;
  overflow: hidden;
  transform: translateX(-50vw);

  .#{$prefix}mcs-background-blur {
    position: absolute;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(24px);
  }
}

.#{$prefix}mcs-background-item {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: block;
  visibility: hidden;
  opacity: 0;
  transition: opacity 300ms ease-in-out, visibility 300ms ease-in-out;
  transition-delay: 300ms;

  &.#{$prefix}active {
    visibility: visible;
    opacity: 1;
    transition-delay: 0ms;
  }

  // fix for firefox that does not support backdrop-filter blur
  &.#{$prefix}blurred {
    filter: blur(24px);
    transform: scale(1.2);
  }
}

/* LOADER START */

.#{$prefix}mcs-loader {
  background-color: rgba(57, 57, 58, 0.2);
  overflow: hidden;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  visibility: hidden;
  opacity: 0;
  z-index: 1;

  .#{$prefix}mcs-loader-element {
    height: 8px;
    width: 100%;

    &::before {
      content: "";
      display: block;
      background-color: v(loadingBarColor);
      height: 8px;
      width: 0%;
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      display: block;
      background-color: v(loadingBarColor);
      height: 8px;
      width: 0%;
    }
  }
}

.#{$prefix}mcs-stages-wrapper {
  &.#{$prefix}autoslider {
    .#{$prefix}mcs-item {
      &.#{$prefix}active {
        .#{$prefix}mcs-loader-element::before {
          width: 100%;
          transition-property: width;
          transition-duration: v(animationTime);
          transition-timing-function: ease-out;
        }

        .#{$prefix}mcs-loader-element {
          &.#{$prefix}fast-forward {
            &::after {
              width: 100%;
              transition-property: width;
              transition-duration: 500ms;
              transition-timing-function: ease-out;
            }
          }
        }
      }
    }
  }

  &:not(.#{$prefix}autoslider) {
    .#{$prefix}mcs-item {
      &.#{$prefix}active {
        .#{$prefix}mcs-loader-element::after {
          width: 100%;
        }
      }
    }
  }

  .#{$prefix}mcs-item {
    &.#{$prefix}active {
      .#{$prefix}mcs-loader {
        visibility: visible;
        opacity: 1;
      }
    }
  }
}

/* LOADER END */

.#{$prefix}mcs-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 48px;
  height: 48px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  z-index: 90;
  -webkit-tap-highlight-color: transparent;
  visibility: hidden;
  opacity: 0;
  transition: opacity 300ms ease-in-out, visibility 300ms ease-in-out;

  &.#{$prefix}mcs-control-left {
    left: calc(50% - 50vw);

    @include for-size(desktop-l-or-larger) {
      left: calc(50% - 1440px * 0.5);
    }

    .#{$prefix}icon-carrier {
      .#{$prefix}icon-content {
        margin-left: -2px;
      }
    }

    /*&:hover {
      .#{$prefix}icon-carrier {
        transform: translateX(-5px);
      }
    }*/
  }

  &.#{$prefix}mcs-control-right {
    left: calc(50% + 50vw);
    transform: translate(-100%, -50%);

    @include for-size(desktop-l-or-larger) {
      left: calc(50% + 1440px * 0.5);
    }

    .#{$prefix}icon-carrier {
      .#{$prefix}icon-content {
        margin-left: 2px;
      }
    }

    /* &:hover {
      .#{$prefix}icon-carrier {
        transform: translateX(5px);
      }
    }*/
  }

  &.#{$prefix}mcs-control-visible {
    visibility: visible;
    opacity: 1;
  }

  .#{$prefix}icon-carrier {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: v(controlColor);
    transition-property: background-color, transform;
    transition-duration: 0.15s;
    transition-timing-function: ease-in-out;

    .#{$prefix}icon-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      color: v(controlIconColor);
      transition-property: color, fill;
      transition-duration: 0.15s;
      transition-timing-function: ease-in-out;
    }
  }

  &:hover {
    .#{$prefix}icon-carrier {
      background-color: v(controlColorHover);

      .#{$prefix}icon-content {
        color: v(controlIconColorHover);
      }
    }
  }
}

.#{$prefix}mcs-wrapper {
  position: relative;
  padding-bottom: 40px;
  padding-top: 70px;
  min-height: 480px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  overflow: hidden;
  width: 100%;
  padding-left: 48px;
  padding-right: 48px;

  @include for-size(tablet) {
    padding-left: 24px;
    padding-right: 24px;
  }

  @include for-size(phone) {
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 16px;
  }

  &.#{$prefix}oversize {
    display: flex;
    overflow: visible;
  }

  &.#{$prefix}has-promo-flag {
    &-normal {
      .#{$prefix}mcs-stages-wrapper-frame {
        // 40px default margin + 1/2 height of normal promo flag (26px)
        margin-bottom: 66px;
      }
    }

    &-small {
      .#{$prefix}mcs-stages-wrapper-frame {
        // 40px default margin + 1/2 height of small promo flag (18px)
        margin-bottom: 58px;
      }
    }
  }
}

.#{$prefix}mcs-stages-wrapper-frame {
  position: relative;
  max-width: 1200px;
  margin: 0 auto 40px;
  width: 100%;
}

.#{$prefix}mcs-stages-wrapper {
  display: flex;
  width: 100%;
  height: 100%;

  &.#{$prefix}is-slider {
    position: relative;
    left: 0;
    transition: left 800ms ease-in-out;
  }

  &.#{$prefix}no-blur {
    .#{$prefix}mcs-item:not(.#{$prefix}active) {
      .#{$prefix}mcs-item-description {
        backdrop-filter: blur(24px);
      }
    }
  }

  &.#{$prefix}no-blur-ff {
    .#{$prefix}mcs-item:not(.#{$prefix}active) {
      .#{$prefix}mcs-item-description-background {
        opacity: 0.97;
      }
    }
  }

  &.#{$prefix}stages-2 {
    justify-content: center;

    .#{$prefix}mcs-item {
      max-width: 450px;
    }
  }

  .#{$prefix}mcs-item {
    flex: 1;
    margin: 0px 8px 0px 8px;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;
    transition: transform 300ms ease-in-out, box-shadow 300ms ease-in-out;

    &:focus {
      outline: none;
    }

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    .#{$prefix}mcs-item-image {
      position: relative;
      width: 100%;
      height: auto;
      z-index: 70;
      padding-top: 8px;
      overflow: hidden;

      &::after {
        @include aspect-ratio(16, 9);
      }

      .#{$prefix}mcs-item-image-inner {
        position: absolute;
        left: 0;
        top: 0;
        transform: translateY(8px);
        width: 100%;
        height: 100%;
        transition: transform 300ms ease-in-out;
        overflow: hidden;
        border-top-left-radius: $multi-content-stage-teaser-top-left-radius;
        border-top-right-radius: $multi-content-stage-teaser-top-right-radius;

        eon-ui-image {
          transition: transform 300ms ease-in-out;
        }
      }
    }

    .#{$prefix}mcs-item-description {
      position: relative;
      flex-grow: 1;

      .#{$prefix}mcs-item-description-background {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background: v(backgroundColor);
        opacity: 0.9;
        transition: box-shadow 300ms ease-in-out, transform 300ms ease-in-out, height 300ms ease-in-out;
        border-bottom-left-radius: $multi-content-stage-teaser-bottom-left-radius;
        border-bottom-right-radius: $multi-content-stage-teaser-bottom-right-radius;
        box-shadow: $multi-content-stage-teaser-shadow;

        &::after {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 10px 10px 0 10px;
          border-color: v(activeBackgroundColor) transparent transparent transparent;
          transform: translateX(-50%);
          opacity: 0;
          transition: bottom 300ms ease-in-out;
        }
      }

      .#{$prefix}mcs-item-description-inner {
        position: relative;
        width: 100%;
        height: auto;
        padding: 24px 24px 24px 24px;
        transition: transform 300ms ease-in-out;
      }
    }

    &.#{$prefix}no-image {
      .#{$prefix}mcs-item-description {
        .#{$prefix}mcs-item-description-inner {
          padding: 24px 24px 32px 24px;
        }

        .#{$prefix}mcs-item-description-background {
          border-top-left-radius: $multi-content-stage-teaser-top-left-radius;
          border-top-right-radius: $multi-content-stage-teaser-top-right-radius;

          .#{$prefix}mcs-loader {
            border-top-right-radius: $multi-content-stage-teaser-top-right-radius;
            border-top-left-radius: $multi-content-stage-teaser-top-left-radius;
          }
        }
      }
    }

    &.#{$prefix}active {
      .#{$prefix}mcs-item-description {
        .#{$prefix}mcs-item-description-background {
          background: v(activeBackgroundColor);
          height: calc(100% + 16px);
          transform: translateY(-8px);
          opacity: 1;
          box-shadow: $multi-content-stage-teaser-active-shadow;

          &::after {
            opacity: 1;
            bottom: -10px;
          }
        }
      }

      .#{$prefix}mcs-item-image {
        .#{$prefix}mcs-item-image-inner {
          transform: translateY(0px);

          eon-ui-image {
            transform: scale(1.03);
          }
        }
      }
    }

    /* &:not(.#{$prefix}active) {
      .#{$prefix}mcs-item-description {
        margin-bottom: 8px;
      }
    } */
  }

  .#{$prefix}mcs-item-headline {
    @include eon-typography($multi-content-stage-headline-declaration);
    padding-bottom: 8px;
    display: flex;
    align-items: flex-start;

    @if variable-exists(multi-content-stage-override-headline-font-size) {
      font-size: $multi-content-stage-override-headline-font-size;
    }

    @if variable-exists(multi-content-stage-override-headline-line-height) {
      line-height: $multi-content-stage-override-headline-line-height;
    }

    eon-ui-icon {
      position: relative;
      //margin-right: 8px;
      margin-right: $multi-content-stage-icon-headline-margin-right;
      margin-top: $multi-content-stage-icon-headline-margin-top;
    }
  }

  .#{$prefix}mcs-item-text {
    @include eon-typography($multi-content-stage-text-declaration);
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;

    @if variable-exists(multi-content-stage-override-text-font-size) {
      font-size: $multi-content-stage-override-text-font-size;
    }

    @if variable-exists(multi-content-stage-override-text-line-height) {
      line-height: $multi-content-stage-override-text-line-height;
    }
  }
}

.#{$prefix}mcs-content-wrapper {
  position: relative;
  padding: 48px 48px 40px 48px;
  background: v(backgroundColor);
  max-width: 1200px;
  margin: -40px auto 0;
  border-radius: $multi-content-stage-content-box-radius;
  box-shadow: $multi-content-stage-content-box-shadow;

  @include for-size(desktop-or-larger) {
    width: 100%;
  }

  @include for-size(desktop) {
    margin-left: 48px;
    margin-right: 48px;
    width: calc(100% - 96px);
  }

  @include for-size(tablet) {
    padding: 40px 32px 40px 32px;
    margin-left: 24px;
    margin-right: 24px;
    width: calc(100% - 48px);
  }

  @include for-size(phone) {
    padding: 24px 24px 32px 24px;
    margin-left: 24px;
    margin-right: 24px;
    margin-top: -16px;
    width: calc(100% - 48px);
  }
}

// @import "multi-content-stage-item/multi-content-stage-item.scss";
